<template>
  <div class="box-input-company">
    <Navbar />
    <div class="input-company">
      <b-form @submit="addCompany">
        <b-container class="box">
          <b-row class="justify-content-center">
            <b-col lg="12" class="text-left title-text">
              <h4>
                <b>บริษัท/ห้าง</b>
              </h4>
            </b-col>
          </b-row>
          <b-row class="justify-content-center">
            <b-col lg="12" class="text-left content-text">
              <b-row>
                <b-col lg="7">
                  <b-row class="justify-content-center">
                    <b-col lg="12" class="text-left title-sub-text">
                      <p class="mb-0">
                        <b>
                          <u>ข้อมูลทั่วไป</u>
                        </b>
                      </p>
                    </b-col>
                  </b-row>
                  <br />
                  <b-row class="justify-content-center">
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5">
                              คำนำหน้า
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <b-form-select
                                size="sm"
                                @change="changeType"
                                v-model="form.ebidding_company_type"
                                :options="option_company_type"
                                required
                              ></b-form-select>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row>
                            <b-col lg="4">
                              ชื่อ
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <b-form-textarea
                                size="sm"
                                v-model="form.ebidding_customer_name"
                                required
                                @input="
                                  form.ebidding_customer_name = form.ebidding_customer_name.trim()
                                "
                                rows="2"
                              ></b-form-textarea>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5">
                              ที่อยู่
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <b-form-textarea
                                size="sm"
                                v-model="form.ebidding_customer_addr1"
                                required
                                rows="6"
                                @input="
                                  form.ebidding_customer_addr1 = form.ebidding_customer_addr1.trim()
                                "
                              ></b-form-textarea>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row>
                            <b-col lg="4">
                              อำเภอ
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <ThailandAutoComplete
                                class="box-auto"
                                v-model="amphoe"
                                required
                                type="amphoe"
                                @select="select"
                              />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col lg="4">
                              จังหวัด
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <ThailandAutoComplete
                                class="box-auto"
                                v-model="province"
                                required
                                type="province"
                                @select="select"
                              />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col lg="4">
                              ไปรษณีย์
                              <span class="required">&nbsp;*</span>
                            </b-col>
                            <b-col>
                              <ThailandAutoComplete
                                class="box-auto"
                                v-model="zipcode"
                                required
                                type="zipcode"
                                @select="select"
                              />
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5"
                              >เบอร์โทร <span class="required">*</span></b-col
                            >
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_tel"
                                @input="
                                  form.ebidding_tel = form.ebidding_tel.trim()
                                "
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row>
                            <b-col lg="4">Email</b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_email"
                                @input="
                                  form.ebidding_email = form.ebidding_email.trim()
                                "
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5"
                              >latitude <span class="required">*</span></b-col
                            >
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.latitude"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row>
                            <b-col lg="4">longitude</b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.longitude"
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5">Line</b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_line"
                                @input="
                                  form.ebidding_line = form.ebidding_line.trim()
                                "
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col>
                          <b-row>
                            <b-col lg="5">
                              วันจดทะเบียน
                              <span class="required">*</span>
                            </b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_register_date"
                                ref="date-input"
                                @input="
                                  form.ebidding_register_date = form.ebidding_register_date.trim()
                                "
                                required
                              ></b-form-input>
                              <small>วว ด.ด. ปปปป (01 ก.พ. 2563)</small>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col>
                          <b-row>
                            <b-col lg="5">
                              ทุนจดทะเบียน
                              <span class="required">*</span>
                            </b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_registered_capital"
                                required
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col lg="10">
                          <b-row>
                            <b-col lg="3">การลงชื่อ</b-col>
                            <b-col>
                              <b-form-select
                                v-model="form.ebidding_sign_condition"
                                :options="options"
                                size="sm"
                                required
                              ></b-form-select>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col lg="10">
                          <b-row>
                            <b-col lg="3">
                              เลขประจำตัวผู้เสียภาษี
                              <span class="required">*</span>
                            </b-col>
                            <b-col>
                              <b-form-input
                                size="sm"
                                v-model="form.ebidding_customer_tax"
                                required
                              ></b-form-input>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col></b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col lg="4">
                          <b-form-checkbox
                            v-model="form.ispartner"
                            value="1"
                            unchecked-value="0"
                            >เป็น Partner</b-form-checkbox
                          >
                        </b-col>
                        <b-col lg="4">
                          <b-row>
                            <b-col lg="12">
                              <b-form-checkbox
                                v-model="form.isnotfound"
                                value="1"
                                unchecked-value="0"
                                >ไม่พบข้อมูล</b-form-checkbox
                              >
                            </b-col>
                            <b-col lg="12" v-if="form.isnotfound === '1'">
                              <b-form-textarea
                                v-model="form.remarks"
                                placeholder="หมายเหตุ"
                                rows="2"
                              ></b-form-textarea>
                            </b-col>
                          </b-row>
                        </b-col>
                        <b-col lg="4">
                          <b-form-checkbox
                            v-model="form.isnocommittee"
                            value="1"
                            unchecked-value="0"
                            >ไม่มีข้อมูลกรรมการ</b-form-checkbox
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                    <br />
                    <br />
                    <b-col lg="12">
                      <b-row>
                        <b-col class="text-center">
                          <b-button size="sm" type="submit" variant="success">
                            <font-awesome-icon
                              icon="save"
                            />&nbsp;บันทึกข้อมูลทั่วไป
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <br />
                    <br />
                  </b-row>
                </b-col>
                <b-col>
                  <b-row class="justify-content-center">
                    <b-col lg="12" class="text-left title-sub-text">
                      <p class="mb-0">
                        <b>
                          <u>กรรมการ/หุ้นส่วนผู้จัดการ</u>
                        </b>
                      </p>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="12">
                      <b-row>
                        <b-col lg="3">
                          ชื่อกรรมการ
                          <span class="required">*</span>
                        </b-col>
                        <b-col>
                          <b-form-textarea
                            size="sm"
                            id="disable3"
                            v-model="name"
                            disabled
                            rows="8"
                          ></b-form-textarea>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col lg="12">
                      <br />
                      <b-row>
                        <b-col lg="3">
                          ตำเเหน่ง
                          <span class="required">*</span>
                        </b-col>
                        <b-col>
                          <b-form-input
                            size="sm"
                            id="disable2"
                            v-model="position"
                            disabled
                          ></b-form-input>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col lg="12">
                      <br />
                      <b-row>
                        <b-col class="text-center">
                          <b-button
                            size="sm"
                            variant="success"
                            id="btnHide"
                            @click="addCommittee"
                          >
                            <font-awesome-icon
                              icon="save"
                            />&nbsp;บันทึกข้อมูลกรรมการ
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col lg="12">
                      <br />
                      <b-row>
                        <b-col class="text-center">
                          <span class="required"
                            >*
                            หมายเหตุกรุณาเพิ่มข้อมูลทั่วไปของบริษัทก่อนเพิ่มกรรมการ</span
                          >
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import axios from "axios";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
export default {
  components: { Navbar, Footer, ThailandAutoComplete },
  mounted() {
    axios.get("http://www.geoplugin.net/json.gp").then((res) => {
      this.ipaddress = res.data.geoplugin_request;
    });
    document.getElementById("btnHide").disabled = true;
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/company_type")
      .then((res) => {
        if (res.data.statusCompany) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.option_company_type.push(
              JSON.parse(
                '{"value": "' +
                  res.data.response[index].company_type +
                  '", "text": "' +
                  res.data.response[index].company_type +
                  '"}'
              )
            );
          }
        } else {
          this.$bvToast.toast(res.data.error, {
            title: "ผิดพลาด",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
          });
        }
      });
  },
  methods: {
    changeType: function () {
      if (
        this.form.ebidding_company_type === "บุคคลธรรมดา" ||
        this.form.ebidding_company_type === "ร้าน" ||
        this.form.ebidding_company_type === "กิจการร่วมค้า" ||
        this.form.ebidding_company_type === "อื่นๆ"
      ) {
        axios
          .get("https://www.kmppartners.info:1009/api/get/tax/alone")
          .then((res) => {
            this.form.ebidding_customer_tax = res.data.response[0].tax_no;
          });
      } else {
        this.form.ebidding_customer_tax = null;
      }
    },
    addCommittee: function () {
      if (
        this.name !== null &&
        this.position !== null &&
        this.name !== "" &&
        this.position !== ""
      ) {
        this.$bvModal
          .msgBoxConfirm("ต้องการบันทึกข้อมูลกรรมการใช่หรือไม่", {
            title: "ต้องการดำเนินการต่อไหม?",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            cancelVariant: "danger",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
            okTitle: "ตกลง",
            cancelTitle: "ยกเลิก",
          })
          .then((value) => {
            if (value) {
              axios
                .post(
                  "https://www.kmppartners.info:1009/api/ebidding/add/committee",
                  {
                    name: this.name.split("\n"),
                    position: this.position,
                    company_id: this.id_company,
                  }
                )
                .then((res) => {
                  if (res.data.statusAddCommittee) {
                    this.$bvModal
                      .msgBoxOk(
                        "บันทึกข้อมูลกรรมการ/หุ้นส่วนผู้จัดการเรียบร้อยเเล้ว",
                        {
                          title: "สำเร็จ",
                          size: "md",
                          buttonSize: "sm",
                          okVariant: "success",
                          headerClass: "p-2 border-bottom-0",
                          footerClass: "p-2 border-top-0",
                          centered: true,
                          okTitle: "ตกลง",
                        }
                      )
                      .then((value) => {
                        if (value) {
                          axios
                            .post(
                              "https://www.kmppartners.info:1009/api/ebidding/access_log",
                              {
                                access_username: this.$session.get("username"),
                                access_module:
                                  "เพิ่มกรรมการผู้ชนะ/หุ้นส่วนผู้จัดการ E-Bidding",
                                access_ipaddress: this.ipaddress,
                              }
                            )
                            .then((rest) => {
                              if (rest.data.statusLog) {
                                this.$router.push("/Company");
                              }
                            });
                        }
                      });
                  }
                });
            }
          });
      } else {
        this.$bvToast.toast(
          'กรุณากรอกข้อมูล "กรรมการ/หุ้นส่วนผู้จัดการ" ให้ครบทุกช่อง',
          {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
          }
        );
      }
    },
    addCompany: function (e) {
      e.preventDefault();
      if (typeof this.form.ebidding_registered_capital === "string") {
        this.form.ebidding_registered_capital = parseFloat(
          this.form.ebidding_registered_capital.replace(/,/g, "")
        );
      }
      let pattern = /^([0-9]{2})( )([ก-๙]{1,3})(.)([ก-๙]{1})(.)( )([0-9]{4})$/;
      if (
        this.form.ebidding_amphoe === "" ||
        this.form.ebidding_changwat === "" ||
        this.form.ebidding_customer_zipcode === ""
      ) {
        this.$bvToast.toast("กรุณากรอกข้อมูลให้ครบทุกช่องก่อนกดบันทึก", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
      } else if (
        this.form.ebidding_amphoe === null ||
        this.form.ebidding_changwat === null ||
        this.form.ebidding_amphoe === null
      ) {
        this.$bvToast.toast(
          'กรุณากรอกข้อมูล "อำเภอ, จังหวัด, ไปรษณีย์" ให้ถูกต้อง',
          {
            title: "ผิดพลาด",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
          }
        );
      } else if (!pattern.test(this.form.ebidding_register_date)) {
        this.$bvToast.toast("กรุณากรอกวันที่ให้ถูกต้อง (วว ด.ด. ปปปป)", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
        this.$refs["date-input"].focus();
      } else if (
        this.form.ebidding_tel === null ||
        this.form.ebidding_tel === ""
      ) {
        this.$bvToast.toast("กรุณากรอกเบอร์โทร", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
      } else {
        if (this.form.ebidding_customer_tax.toString().length === 13) {
          if (
            this.form.ebidding_tel !== null &&
            this.form.ebidding_tel !== ""
          ) {
            this.form.ebidding_tel = this.form.ebidding_tel.replace(/ /g, "");
            this.form.ebidding_tel = this.form.ebidding_tel.replace("+66", "0");
            this.form.ebidding_tel = this.form.ebidding_tel.replace(/-/g, "");
            this.form.ebidding_tel = this.form.ebidding_tel.replace(/\(/g, "");
            this.form.ebidding_tel = this.form.ebidding_tel.replace(/\)/g, "");
          }
          this.$bvModal
            .msgBoxConfirm("ต้องการบันทึกข้อมูลบริษัท/ห้างหุ้นส่วนใช่หรือไม่", {
              title: "ต้องการดำเนินการต่อไหม?",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              cancelVariant: "danger",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "ตกลง",
              cancelTitle: "ยกเลิก",
            })
            .then((value) => {
              if (value) {
                this.form.creator = this.$session.get("username");
                axios
                  .post(
                    "https://www.kmppartners.info:1009/api/ebidding/add/company",
                    this.form
                  )
                  .then((res) => {
                    if (res.data.statusAddCompany) {
                      if (this.form.isnocommittee === "0") {
                        this.$bvModal
                          .msgBoxOk(
                            'บันทึกข้อมูลทั่วไปเรียบร้อยเเล้ว กรุณาบันทึกข้อมูล "กรรมการ/หุ้นส่วนผู้จัดการ"',
                            {
                              title: "สำเร็จ",
                              size: "md",
                              buttonSize: "sm",
                              okVariant: "success",
                              headerClass: "p-2 border-bottom-0",
                              footerClass: "p-2 border-top-0",
                              centered: true,
                              okTitle: "ตกลง",
                            }
                          )
                          .then((value) => {
                            if (value) {
                              axios
                                .post(
                                  "https://www.kmppartners.info:1009/api/ebidding/access_log",
                                  {
                                    access_username: this.$session.get(
                                      "username"
                                    ),
                                    access_module: "เพิ่มผู้ชนะ E-Bidding",
                                    access_ipaddress: this.ipaddress,
                                  }
                                )
                                .then((rest) => {
                                  if (rest.data.statusLog) {
                                    this.id_company =
                                      res.data.response.insertId;
                                    document.getElementById(
                                      "disable3"
                                    ).disabled = false;
                                    document.getElementById(
                                      "disable2"
                                    ).disabled = false;
                                    document.getElementById(
                                      "btnHide"
                                    ).disabled = false;
                                  }
                                });
                            }
                          });
                      } else {
                        this.$bvModal
                          .msgBoxOk("บันทึกข้อมูลทั่วไปเรียบร้อยเเล้ว", {
                            title: "สำเร็จ",
                            size: "md",
                            buttonSize: "sm",
                            okVariant: "success",
                            headerClass: "p-2 border-bottom-0",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                            okTitle: "ตกลง",
                          })
                          .then((value) => {
                            if (value) {
                              this.$router.push("/Company");
                            }
                          });
                      }
                    } else {
                      this.$bvModal
                        .msgBoxOk(res.data.error, {
                          title: "ผิดพลาด",
                          size: "md",
                          buttonSize: "sm",
                          okVariant: "danger",
                          headerClass: "p-2 border-bottom-0",
                          footerClass: "p-2 border-top-0",
                          centered: true,
                          okTitle: "ตกลง",
                        })
                        .then((value) => {
                          if (value) {
                            location.reload();
                          }
                        });
                    }
                  });
              }
            });
        } else {
          this.$bvToast.toast(
            'กรุณากรอกข้อมูล "เลขประจำตัวผู้เสียภาษีให้ครบ 13 หลัก" ',
            {
              title: "ผิดพลาด",
              autoHideDelay: 3000,
              appendToast: true,
              variant: "danger",
            }
          );
        }
      }
    },
    select(address) {
      this.amphoe = address.amphoe;
      this.province = address.province;
      this.zipcode = address.zipcode;
      this.form.ebidding_amphoe = this.amphoe;
      this.form.ebidding_changwat = this.province;
      this.form.ebidding_customer_zipcode = this.zipcode;
    },
  },
  data() {
    return {
      ipaddress: null,
      id_company: null,
      name: null,
      position: null,
      amphoe: "",
      province: "",
      zipcode: "",
      form: {
        ebidding_company_type: "บริษัท",
        ebidding_customer_name: null,
        ebidding_customer_addr1: null,
        ebidding_amphoe: null,
        ebidding_changwat: null,
        ebidding_customer_zipcode: null,
        ebidding_tel: null,
        ebidding_email: null,
        ebidding_line: null,
        ebidding_customer_tax: null,
        ebidding_register_date: null,
        ebidding_registered_capital: null,
        latitude:null,
        longitude:null,
        ebidding_sign_condition: 1,
        creator: null,
        ispartner: "0",
        isnotfound: "0",
        remarks: "",
        isnocommittee: "0",
      },
      option_company_type: [],
      options: [
        { value: 1, text: "กรรมการหนึ่งคนลงลายมือชื่อ" },
        { value: 2, text: "กรรมการคนใดคนหนึ่งลงลายมือชื่อ" },
        {
          value: 3,
          text: "กรรมการหนึ่งคนลงลายมือชื่อและประทับตราสำคัญของบริษัท",
        },
        {
          value: 4,
          text: "กรรมการคนใดคนหนึ่งลงลายมือชื่อและประทับตราสำคัญของบริษัท",
        },
        { value: 5, text: "กรรมการสองคนลงลายมือชื่อร่วมกัน" },
        {
          value: 6,
          text: "กรรมการสองคนลงลายมือชื่อร่วมกันและประทับตราสำคัญของบริษัท",
        },
        { value: 7, text: "กรรมการสามคนลงลายมือชื่อร่วมกัน" },
      ],
    };
  },
};
</script>

<style>
.box-input-company {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.input-company {
  font-family: "K2D";
  margin: 5% !important;
  padding-bottom: 10%;
}
@media (max-width: 600px) {
  .input-company {
    padding-bottom: 80% !important;
  }
}
@media (max-width: 1024px) {
  .input-company {
    margin-bottom: 20% !important;
  }
}
.title-sub-text {
  margin: 1%;
}
.box-auto {
  padding-right: 0px !important;
  padding-left: 0px !important;
}
</style>
